//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import defaultMenu from '../../assets/src/default-menu'
import supercats from '../../assets/src/supercategories'

export default {
    data() {
        return {
            defaultMenu: defaultMenu,
            supercats: supercats,
            product: null,
            activeProduct: null,
            modifiers: [],
            cost: 0,
            quantity: 1,
            added: false,
            customize: false,
            activeModifier: 0
        }
    },
    computed: {
        ...mapState(['loading', 'activeMenu', 'location']),
        cat() {
            return parseInt(this.$route.query.cat)
        },
        id() {
            return parseInt(this.$route.query.id)
        },
        cartId() {
            return this.$route.query.cid
        },
        // order() {
        //   return this.activeOrder
        // },
        menu() {
            return this.activeMenu
        },
        default() {
            return this.defaultMenu
        },
        loc() {
            return this.location
        },
        productImage() {
            if (this.product.images) {
                let imagepath = this.product.imagepath
                this.product.images.map(i => {
                    if ((this.customize && i.groupname == 'desktop-customize') || i.groupname == 'desktop-customize') {
                        imagepath += i.filename
                    }
                })
                return imagepath
            } else {
                return 'https://a.storyblok.com/f/99717/x/55504e26d1/perkins-default-icon.svg'
            }
        },
        order() {
            return this.$store.state.activeOrder
        },
        menu() {
            return this.$store.state.activeMenu
        },
        loc() {
            return this.$store.state.location
        }
    },
    async asyncData({ $storyblok, store, route }) {
        const page = await $storyblok.getPage('pages/order/product')
        store.commit('setPage', page)
        // store.commit('setRedirect', route.fullPath)
        return {
            page: page,
        }
    },
    head() {
        return this.$metadata(this.page)
    },
    async mounted() {
        // this.defaultMenu = defaultMenu
        this.$store.commit('setPage', this.page)
        if (this.menu) {
            this.processProduct()
        }
    },
    updated: function () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been re-rendered        
            if (this.product) {                
                this.addToDataLayersGA(this.product, this.location, "view_item", 1)
            }
        })
    },
    methods: {
        back() {
            let cats = this.menu.categories
            let supercats = this.supercats
            let i = 0
            let i2 = 0
            for (i = 0; i < cats.length; i++) {
                if (cats[i]['id'] == this.cat) {
                    let name = cats[i]['name'].trim()
                    let hash = ''
                    if (this.supercats['favorites'].includes(name)) hash = 'favorites'
                    if (this.supercats['breakfast'].includes(name)) hash = 'breakfast'
                    if (this.supercats['lunch-and-dinner'].includes(name)) hash = 'lunch-and-dinner'
                    if (this.supercats['bakery'].includes(name)) hash = 'bakery'
                    if (this.supercats['kids'].includes(name)) hash = 'kids'
                    if (this.supercats['beverages'].includes(name)) hash = 'beverages'
                    if (hash !== '') {
                        window.location.href = this.loc.menu_id ? '/order/#' + hash : '/menu/#' + hash
                    } else {
                        window.location.href = this.loc.menu_id ? '/order/' : '/menu/'
                    }
                }
            }
        },
        addToDataLayersGA(product, location, eventType, quantity) {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            // const index = dataLayer.findIndex(object => {
            //     return object.event == eventType
            // })
            // if (index > -1) {
            //     dataLayer.splice(index, 1)
            // }
            dataLayer.push({
                event: eventType,
                ecommerce: {
                    currency: "USD",
                    value: product.cost,
                    items: [{
                        item_id: product.sku,
                        item_name: product.name,
                        item_category: product.category,
                        location_id: location.id,
                        price: product.cost,
                        quantity: quantity
                    }]
                }
            });
        },
        async processProduct() {
            this.added = false
            if (this.menu && this.menu.categories) {
                this.menu.categories.map(c => {
                    c.products.map(p => {
                        if (p && parseInt(p.sku) == parseInt(this.id)) {
                            this.activeProduct = p
                        }
                    })
                })
            }
            if (!this.activeProduct) {
                this.default.categories.map(c => {
                    c.products.map(p => {
                        if (p && parseInt(p.sku) == parseInt(this.id)) {
                            this.activeProduct = p
                            this.activeProduct.missing = true
                        }
                    })
                })
            }

            let product = null
            // if(!this.activeProduct.modifiers) {
            if (this.loading) {
                setTimeout(this.processProduct, 500)
                return
            }
            this.$store.commit('setLoading', true)
            let menu_id = this.loc.menu_id
            if (!menu_id || (this.activeProduct && this.activeProduct.missing)) {
                menu_id = process.env.DEFAULT_MENU
            }
            product = await this.$api.getProduct(menu_id, this.activeProduct.sku)
            if (product) {
                if (this.activeProduct && this.activeProduct.missing) {
                    product.missing = true
                } else {
                    // this.updateProduct(product)
                }
            }
            // } else {
            //   product = this.activeProduct
            // }
            if (product) {
                this.product = JSON.parse(JSON.stringify(product))
                this.modifiers = this.setDefaults(product.modifiers)
                if (product.modifiers.length > 0) {
                    this.activeModifier = product.modifiers[0].id
                }
                this.updateCost()
                this.$store.commit('setLoading', false)
            }
        },
        showCustom(bool) {
            this.customize = bool
            if (bool == false) {
                this.modifiers = this.setDefaults(this.product.modifiers)
            }
        },
        updateProduct(prd) {
            let menu = JSON.parse(JSON.stringify(this.menu))
            this.menu.categories.map((c, i) => {
                c.products.map((p, j) => {
                    if (p.sku == this.id) {
                        menu.categories[i].products[j] = prd
                    }
                })
            })
            this.$store.commit('setActiveMenu', menu)
        },
        getCartOption(oid) {
            let option = null
            if (this.order) {
                this.order.products.map((p) => {
                    if (p.product_id == this.cartId) {
                        this.quantity = p.quantity
                        p.choices.map((c) => {
                            if (oid == c.option_id) {
                                option = c
                            }
                        })
                    }
                })
            }
            return option
        },
        setDefaults(modifiers) {
            let mods = JSON.parse(JSON.stringify(modifiers))
            mods.map(m => {
                m.options.map(o => {
                    if (this.cartId) {
                        const option = this.getCartOption(o.id)
                        if (option) {
                            o.selected = true
                        }
                    } else if (o.default) {
                        o.selected = true
                    }
                    if (o.modifiers) {
                        o.modifiers = this.setDefaults(o.modifiers)
                    }
                })
            })
            return mods
        },
        decreaseQuantity() {
            if ((!this.product.quantities.min || this.quantity > this.product.quantities.min) && this.quantity > 1) {
                this.quantity -= this.product.quantities.increments || 1
            }
        },
        increaseQuantity() {
            if (!this.product.quantities.max || this.quantity < this.product.quantities.max) {
                this.quantity += this.product.quantities.increments || 1
            }
        },
        addModifier(mid, id, q) {
            let modifiers = JSON.parse(JSON.stringify(this.modifiers))
            this.modifiers = this.activateModifier(modifiers, mid, id, q)
            this.updateCost()
        },
        setActiveMod(mod) {
            this.activeModifier = mod
        },
        activateModifier(modifiers, mid, id, q) {
            modifiers.map(m => {
                if (m.id == mid) {
                    let s = m.selects
                    console.log(s)
                    m.options.map(o => {
                        if (s.mandatory && !s.min && !s.max) {
                            if (o.id == id) {
                                o.selected = true
                            } else {
                                o.selected = false
                            }
                        } else if (o.id == id && !s.min && !s.max) {
                            o.selected = !o.selected
                        } else if (o.id == id) {
                            let totals = 0
                            m.options.map(p => {
                                if (p.selected) {
                                    totals += p.selected
                                }
                            })
                            if (
                                (q <= 0 && totals >= s.min - 1 && typeof o.selected == 'number')
                                || (q > 0 && totals < s.max)
                            ) {
                                if (!o.selected) {
                                    o.selected = 1
                                } else {
                                    o.selected += q
                                }
                            }
                        }
                    })
                }
                m.options.map(o => {
                    if (o.modifiers) {
                        o.modifiers = this.activateModifier(o.modifiers, mid, id, q)
                    }
                })
            })
            return modifiers
        },
        updateCost() {
            this.cost = this.getModifierCost(this.product.cost, this.modifiers)
        },
        getModifierCost(cost, mods) {
            mods.map(m => {
                m.options.map(o => {
                    if (o.selected) {
                        cost += o.cost
                    }
                    if (o.modifiers) {
                        cost = this.getModifierCost(cost, o.modifiers)
                    }
                })
            })
            return cost
        },

        async addToCart() {
            const errors = this.checkModifiers([], this.modifiers)
            console.log(errors)
            if (errors.length == 0) {
                this.$store.commit('setLoading', true)
                let order = null
                console.log(this.order)
                if (!this.order) {
                    order = await this.$api.createOrder(this.loc.menu_id)
                    console.log('setting order')
                    console.log('test')
                    this.$store.commit('setActiveOrder', order)
                }
                const product = {
                    id: this.cartId ? parseInt(this.cartId) : this.activeProduct.id,
                    quantity: this.quantity,
                    choices: this.addChoicesToProduct([], this.modifiers)
                }




                if (this.order.products) {
                    const prd = this.order.products.find(p => {
                        return p.product_id === product.id
                    })
                    console.log('prd')
                    console.log(prd)
                    const productToMatch = prd ?
                        {
                            id: prd.product_id,
                            quantity: prd.quantity,
                            choices: prd.choices.map(c => {
                                return {
                                    id: c.option_id,
                                    quantity: c.quantity
                                }
                            })
                        } : {}

                    // if(JSON.stringify({id:productToMatch.id,choices:productToMatch.choices}) === JSON.stringify({id:product.id,choices:product.choices}) ){
                    //   console.log('can update this products quantity')

                    //   const productToUpdate = {
                    //     id: prd.product_id,
                    //     quantity: this.quantity,
                    //     choices:  prd.choices.map((c) =>  c.option_id ).join(',') 
                    //   }  

                    //   order = await this.$api.updateInOrder(this.order.id, prd.id, productToUpdate) 

                    //   if(order) {
                    //     console.log('updating quantity')
                    //     this.$store.commit('setActiveOrder', order)
                    //   } 

                    //   this.$store.commit('setLoading', false)  
                    //   this.$store.commit('setGlobalCart', true) 
                    //   console.log('Product QTY has been updated!');

                    // } else if ((JSON.stringify({id:productToMatch.id}) === JSON.stringify({id:product.id}) ) && (JSON.stringify({choices:productToMatch.choices}) != JSON.stringify({choices:product.choices}) )) {
                    //   console.log('can update this products choices')

                    //   const productToUpdate = {
                    //     id: product.id,
                    //     quantity: this.quantity,
                    //     choices:  product.choices.map((c) =>  c.id ).join(',')
                    //   }

                    //   order = await this.$api.updateInOrder(this.order.id, prd.id, productToUpdate) 

                    //   if(order) {
                    //     console.log('updating choices')
                    //     this.$store.commit('setActiveOrder', order)
                    //   } 

                    //   this.$store.commit('setLoading', false) 
                    //   this.$store.commit('setGlobalCart', true)
                    //   console.log('Product choices have been updated!');

                    // } else {
                    console.log('No Product to update')
                    order = await this.$api.addToOrder(this.order.id, [product])

                    if (order) {
                        console.log('adding to order')
                        this.$store.commit('setActiveOrder', order)
                        this.$store.commit('setGlobalCart', true)
                        this.addToDataLayersGA(this.product, this.location, "add_to_cart", this.quantity)
                    } else {
                        // do something with the error
                    }
                    this.$store.commit('setLoading', false)
                    // } 
                }

            } else {
                this.$store.commit('setActiveErrors', errors)
                // show errors
            }
        },

        checkModifiers(errors, mods) {
            mods.map(m => {
                let s = m.selects
                let selected = 0
                m.options.map(o => {
                    if (o.selected) {
                        selected += 1
                        if (o.modifiers) {
                            errors = this.checkModifiers(errors, o.modifiers)
                        }
                    }
                })
                if (s.mandatory) {
                    if (!s.min && !s.max && selected != 1) {
                        // valid = false
                        errors.push(`No selection made for ${m.name}.`)
                    } else {
                        if (s.min && selected < s.min) {
                            // valid = false
                            errors.push(`Minimum ${s.min} required for ${m.name} (you have ${selected}).`)
                        }
                        if (s.max && selected > s.max) {
                            // valid = false
                            errors.push(`Maximum ${s.max} required for ${m.name} (you have ${selected}).`)
                        }
                    }
                }
            })
            return errors
        },
        addChoicesToProduct(choices, mods) {
            mods.map(m => {
                m.options.map(o => {
                    if (o.selected) {
                        choices.push({
                            id: o.id,
                            quantity: typeof o.selected == 'number' ? o.selected : 1
                        })
                        if (o.modifiers) {
                            choices = this.addChoicesToProduct(choices, o.modifiers)
                        }
                    }
                })
            })
            return choices
        }
    },
    watch: {
        '$route.query'() {
            console.log('this.$route.query.id:::: ', this.$route.query.id)
            this.processProduct()
        },
        'menu': function (e) {
            console.log(this.id, this.product)
            if (!this.proudct) {
                // this.processProduct()
            }
        }
    }
}
